import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getCustomRoleByPermissionRequest,
  putCustomRoleByPermissionRequest,
  putCustomRoleByPermissionResponseClear,
} from "../../../../Redux/Settings/SettingsActions";
import CustomButton from "../../../../Components/Atoms/CustomButton";
import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
} from "@mui/material";
import { useFormik } from "formik";
import toast from "react-hot-toast";
import { getUserRequest } from "../../../../Redux/GetUser/GetUserActions";

const ViewCustomRole = ({ _id, handleClose }) => {
  const dispatch = useDispatch();
  const {
    getCustomRoleByPermissionLoading,
    getCustomRoleByPermissionResponse,
    putCustomRoleByPermissionLoading,
    putCustomRoleByPermissionResponse,
  } = useSelector((state) => state.settingsReducer);

  useEffect(() => {
    if (_id) {
      dispatch(getCustomRoleByPermissionRequest({ _id }));
    }
  }, [_id]);

  const [permissionsData, setPermissionsData] = useState([]);
  const [selected, setSelected] = useState(new Set());

  useEffect(() => {
    const fetchPermissions = async () => {
      setPermissionsData(getCustomRoleByPermissionResponse?.data);
      const preSelected = new Set();
      getCustomRoleByPermissionResponse?.data?.forEach((mod) => {
        mod.permissions.forEach((perm) => {
          if (perm.checked) preSelected.add(perm.id);
        });
      });
      setSelected(preSelected);
    };
    fetchPermissions();
  }, [getCustomRoleByPermissionResponse]);

  const togglePermission = (permId) => {
    const updated = new Set(selected);
    updated.has(permId) ? updated.delete(permId) : updated.add(permId);
    setSelected(updated);
  };

  const formik = useFormik({
    initialValues: {},
    onSubmit: () => {
      dispatch(
        putCustomRoleByPermissionRequest({
          _id,
          permission_refs: Array.from(selected),
        })
      );
    },
  });

  useEffect(() => {
    if (putCustomRoleByPermissionResponse?.success) {
      toast.success(putCustomRoleByPermissionResponse?.message);
      dispatch(getUserRequest());
      handleClose();
    } else if (putCustomRoleByPermissionResponse?.response?.data) {
      toast.error(putCustomRoleByPermissionResponse?.response?.data?.message);
    }
    dispatch(putCustomRoleByPermissionResponseClear());
  }, [putCustomRoleByPermissionResponse]);

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <div className="tblWrpr mb-15">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>S.NO</th>
                  <th>MODULE</th>
                  <th>ACTIONS</th>
                </tr>
              </thead>
              <tbody>
                {permissionsData?.map((mod, index) => (
                  <tr key={mod.module}>
                    <td>{index + 1}</td>
                    <td>{mod.module}</td>
                    <td>
                      <Box display="flex" gap={2} flexWrap="wrap">
                        {mod.permissions?.map((perm) => (
                          <Box
                            key={perm.id}
                            display="flex"
                            flexDirection="column"
                            alignItems="center"
                            minWidth={100}
                          >
                            <Checkbox
                              checked={selected.has(perm.id)}
                              onChange={() => togglePermission(perm.id)}
                              color="primary"
                            />
                            <Typography
                              variant="body2"
                              align="center"
                              whiteSpace="nowrap"
                            >
                              {`(${perm.name})`}
                            </Typography>
                          </Box>
                        ))}
                      </Box>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="btnActnBar">
            <CustomButton
              btnType="secondary"
              onClick={handleClose}
              label={"Cancel"}
              action={"CANCEL"}
            />
            <CustomButton
              label={putCustomRoleByPermissionLoading ? "Loading..." : "Save"}
              type="submit"
              action={"SAVE"}
            />
          </div>
        </div>
      </form>
    </>
  );
};
export default ViewCustomRole;
